/**
 * Reusable stateless form component for StudyUser
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";

// import actions
import * as studyUserActions from '../../studyUser/studyUserActions';
import * as userEventActions from '../../userEvent/userEventActions';

import _ from 'lodash';
import { DateTime } from 'luxon';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

class UserActivityCard extends Base {
  constructor(props) {
    super(props);
    this.state = {
      confirmEmailReminder: false
      , resultModalOpen: false
      , resultMessage: ""
      , resultType: "info"
      , sendingEmail: false
    }
    this._bind(
      '_resendInvitation'
    )
  }

  _resendInvitation() {
    this.setState({sendingEmail: true})
    const { dispatch, studyUser } = this.props;
    this.props.dispatch(studyUserActions.sendReInviteStudyUser(studyUser)).then(inviteRes => {
      if(inviteRes.success) {
        this.setState({
          confirmEmailReminder: false
          , resultModalOpen: true
          , resultMessage: "Email sent"
          , resultType: "success"
          , sendingEmail: false
        });
        } else {
        this.setState({
          confirmEmailReminder: false
          , resultModalOpen: true
          , resultMessage: inviteRes.error
          , resultType: "danger"
          , sendingEmail: false
        });
        }
    })
  }

  render() {
    const {
      isArchived
      , studyUser
      , user
      , userEvents
    } = this.props;
    const sorted = _.orderBy(userEvents, [item => item.created], ['desc']);

    const btnClass = classNames(
      'yt-btn'
      , 'x-small'
      , 'u-pullRight'
      , 'danger'
      , { 'disabled': isArchived }
    )

    return (
      <div className="content-container">
        <div className="yt-row space-between center-vert">
          <p><strong>User Activity</strong></p>
          { studyUser ?
              <div data-tip data-for={studyUser._id}>
                <button type="button" className={btnClass} onClick={() => this.setState({confirmEmailReminder: true})} > Re-send email invite</button>
              </div>
            :
              null
          }
        </div>
        <hr/>
        <small><strong>First Invited</strong></small>
        <p>{DateTime.fromISO(studyUser.created).toLocaleString(DateTime.DATETIME_SHORT)}</p>
        <small><strong>Last Login</strong></small>
        <p>{user && user.lastLogin ? DateTime.fromISO(user.lastLogin).toLocaleString(DateTime.DATETIME_SHORT) : 'n/a'}</p>
        <small><strong>Last activity</strong></small>
        <p>{sorted[0] ? sorted[0].eventAction : null } - {sorted[0] ? DateTime.fromISO(sorted[0].created).toLocaleString(DateTime.DATETIME_SHORT) : null }</p>

        <br/>
          <AlertModal
            alertMessage={<div><strong>CAUTION: </strong> Are you <em>sure</em> you want to resend the invitation? <br/> This will also reset the user's password.</div>}
            alertTitle="Confirm resend invitation"
            closeAction={() => this.setState({confirmEmailReminder: false})}
            declineText="Nevermind"
            disabled={this.state.sendingEmail}
            confirmAction={this._resendInvitation}
            confirmText={this.state.sendingEmail ? "Sending..." : "Yes, resend invite"}
            isOpen={this.state.confirmEmailReminder}
            type="danger"
          />
          <AlertModal
            alertMessage={this.state.resultMessage}
            alertTitle="Invitation result"
            closeAction={() => this.setState({resultModalOpen: false})}
            disabled={this.state.sendingEmail}
            confirmAction={() => this.setState({resultModalOpen: false})}
            confirmText="Got it"
            isOpen={this.state.resultModalOpen}
            type={this.state.resultType}
          />
      </div>
    )
  }
}

UserActivityCard.propTypes = {
  dispatch: PropTypes.func.isRequired
  , isArchived: PropTypes.bool
  , studyUser: PropTypes.object
  , user: PropTypes.object.isRequired
  , userEvents: PropTypes.array
  , viewingAs: PropTypes.string
}

UserActivityCard.defaultProps = {
  studyUser: null
  , userEvents: []
  , viewingAs: 'study-admin'
}

const mapStoreToProps = (store) => {
  return {
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UserActivityCard)
);



// WEBPACK FOOTER //
// modules/user/components/UserActivityCard.js.jsx